module.exports = __webpack_public_path__ + "img/arrow.766879f4.svg";